import React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../lib/utils';

const buttonVariants = cva(
  // Base styles
  "w-full h-12 bg-secondary border-4 border-secondary hover:bg-primary-light hover:border-primary-light hover:text-primary text-surface-light font-dillan uppercase rounded-full transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2",
  {
    variants: {
      variant: {
        primary: "bg-secondary text-surface-light hover:bg-primary-light",
        secondary: "bg-accent-light text-surface-dark hover:bg-accent-light",
        accent: "bg-accent-light text-surface-dark hover:bg-accent-light",
        outline: "bg-primary-dark border-4 border-primary-dark text-surface-light hover:bg-surface hover:border-surface hover:text-neutral",
      },
      size: {
        sm: "px-3 py-1 text-sm",
        md: "px-5 py-2 text-m",
        lg: "px-6 py-3 text-l",
      },
      responsive: {
        mobile: "w-full px-5 py-4 text-base sm:w-auto sm:px-6 sm:py-3", // Full width on mobile, normal on larger screens
      }
    },
    defaultVariants: {
      variant: "secondary",
      size: "md",
    }
  }
);

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  as?: 'button' | 'a';
  href?: string;
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant, size, responsive, as = 'button', href, ...props }, ref) => {
    const Comp = as;
    const buttonProps = as === 'a' ? { href, ...props } : props;

    return (
      <Comp
        className={cn(buttonVariants({ variant, size, responsive, className }))}
        ref={ref as any}
        {...buttonProps}
      />
    );
  }
);

Button.displayName = 'Button';

export default Button;